import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "gfu-heading gfu-heading--main gfu-heading--inline _py-6",
  "data-qa": "payment-success:Title"
}
const _hoisted_2 = { class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider-center" }
const _hoisted_3 = {
  "format-key": "0",
  "data-qa": "pledge-success:ProjectName"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "_ba-2 _bc--accent _rounded--common _tc--accent _inline-block gfu-cloud _mt-3"
}
const _hoisted_6 = {
  "format-key": "0",
  "data-qa": "pledge-success:BackerNumber"
}
const _hoisted_7 = { class: "_flex _jc-c _ai-c _mt-3 _mb-3" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "_tal" }
const _hoisted_10 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_11 = { class: "_mt-0" }
const _hoisted_12 = { class: "_tal" }
const _hoisted_13 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_14 = { class: "_mt-0" }
const _hoisted_15 = { class: "gfu-hd gfu-hd--h2 _mb-3" }
const _hoisted_16 = { "format-key": "0" }
const _hoisted_17 = {
  key: 0,
  class: "_mt-6"
}
const _hoisted_18 = {
  key: 0,
  class: "_flex-basis-30 _flexcol _ai-st"
}
const _hoisted_19 = { class: "gfu-heading gfu-heading--main gfu-heading--inline _py-6" }
const _hoisted_20 = { class: "_flexcol _gap-6 gfu-scrollable-content-inner" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_circle_icon = _resolveComponent("circle-icon")
  const _component_box = _resolveComponent("box")
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_payment_success_stretch_goals = _resolveComponent("payment-success-stretch-goals")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_payment_success_faq_section = _resolveComponent("payment-success-faq-section")
  const _component_newsletter_subscription_banner = _resolveComponent("newsletter-subscription-banner")
  const _component_project_card = _resolveComponent("project-card")
  const _component_scrollable_wrapper = _resolveComponent("scrollable-wrapper")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { class: "gfu-layout__main" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['_flex _gap-6', {'_fd-c': $options.isMobile } ] )
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{'_flex-basis-70' : !$options.isMobile }])
        }, [
          _createElementVNode("h1", _hoisted_1, _toDisplayString($options.detailsSectionHeaderText), 1 /* TEXT */),
          _createVNode(_component_box, { class: "_tac" }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_2, [
                _createVNode(_component_localize, { resource: $options.headerResource }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString($options.projectName), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ]),
              (!_ctx.isProjectRetailType)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($options.subheader), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($props.backerNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_localize, {
                      resource: _ctx.Resources.PaymentSuccess.BackerNumberMessage
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString($props.backerNumber), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["resource"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_base_image, {
                  width: "120",
                  height: "120",
                  src: $props.projectThumbnail,
                  loading: "lazy",
                  class: "_bxsh--base _rounded--common",
                  alt: "project image"
                }, null, 8 /* PROPS */, ["src"]),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-success-box-logo" }, null, -1 /* CACHED */)),
                _createVNode(_component_base_image, {
                  src: $props.userAvatarUrl,
                  width: "120",
                  height: "120",
                  loading: "lazy",
                  class: "gfu-avatar gfu-avatar--clean",
                  alt: "user avatar"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              ($options.isYourPledgeButtonVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_base_button, {
                      tag: "a",
                      href: $props.yourPledgeUrl,
                      class: "_mb-3",
                      theme: "accent",
                      onClick: $options.requestInAppReview,
                      "data-qa": "pledge-success-link:YourPledge"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.returnActionButtonText), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href", "onClick"])
                  ]))
                : _createCommentVNode("v-if", true),
              ($props.isOvercharged)
                ? (_openBlock(), _createBlock(_component_base_notificator, {
                    key: 3,
                    type: "error",
                    "can-close": false,
                    class: "_mb-6",
                    message: _ctx.Resources.PaymentSuccess.NotificatorOverpaidOrderErrorMessage
                  }, null, 8 /* PROPS */, ["message"]))
                : _createCommentVNode("v-if", true),
              ($options.orderStatusExplanation)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(['_flex _gap-3 _mb-6', {'_flexwrap': $options.isMobile}])
                  }, [
                    _createVNode(_component_box, {
                      slim: "",
                      nested: "",
                      class: _normalizeClass(['_tac _flex', $options.classes])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_circle_icon, {
                          icon: "check",
                          theme: "success",
                          size: "large",
                          class: "_mr-2 _shrink-0"
                        }),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h3", _hoisted_10, _toDisplayString($options.orderStatusExplanation.text), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_11, _toDisplayString($options.orderStatusExplanation.sub), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_box, {
                      slim: "",
                      nested: "",
                      class: _normalizeClass(['_tac _flex', $options.classes])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_circle_icon, {
                          icon: "clock",
                          theme: "disabled",
                          size: "large",
                          class: "_mr-2 _shrink-0"
                        }),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.Resources.PaymentSuccess.StepHeader), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_14, _toDisplayString($options.orderStatusExplanation.next), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              ($props.hasProjectMessage)
                ? (_openBlock(), _createBlock(_component_box, {
                    key: 5,
                    nested: "",
                    class: _normalizeClass(['_tac', {'_mb-6': $options.isStretchGoalsSectionVisible}]),
                    "data-qa": "payment-success:SpecialThanks"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_15, [
                        _createVNode(_component_localize, {
                          resource: _ctx.Resources.PaymentSuccess.PaymentSuccessCreatorCustomMessageTitle
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_16, _toDisplayString($options.creatorName), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["resource"])
                      ]),
                      _createVNode(_component_content_renderer, {
                        class: "gfu-richtext",
                        content: $props.paymentSuccessCreatorMessage,
                        "data-qa": "payment-success:SpecialThanksMessage"
                      }, null, 8 /* PROPS */, ["content"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"]))
                : _createCommentVNode("v-if", true),
              ($options.isStretchGoalsSectionVisible)
                ? (_openBlock(), _createBlock(_component_payment_success_stretch_goals, _normalizeProps(_mergeProps({ key: 6 }, $options.paymentSuccessStretchGoalsProps)), null, 16 /* FULL_PROPS */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          ($options.isMobile)
            ? (_openBlock(), _createBlock(_component_project_recommendations, {
                key: 0,
                quantity: 4,
                title: _ctx.Resources.Comments.ProjectRecommendationsTitle,
                "exclude-project-ids": [_ctx.projectContext.projectID],
                source: "payment-success",
                class: "_mt-6"
              }, null, 8 /* PROPS */, ["title", "exclude-project-ids"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_box, { class: "_mt-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_payment_success_faq_section, _normalizeProps(_guardReactiveProps($options.faqSectionModel)), null, 16 /* FULL_PROPS */),
              ($props.hasNewsletterSubscriptionBanner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_newsletter_subscription_banner)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ], 2 /* CLASS */),
        (!$options.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.Resources.PaymentSuccess.RecommendationSectionHeader), 1 /* TEXT */),
              _createVNode(_component_scrollable_wrapper, {
                "scroll-direction": $data.scrollDirections.vertical
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.recommendationItems, (recommendation) => {
                      return (_openBlock(), _createBlock(_component_project_card, _mergeProps({
                        key: recommendation.project.projectID
                      }, { ref_for: true }, recommendation.project), null, 16 /* FULL_PROPS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["scroll-direction"])
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }))
}